var map = {
	"./alien.png": 33074,
	"./angry.png": 50135,
	"./blank.png": 50557,
	"./blue.png": 16826,
	"./broken_heart.png": 23959,
	"./brown.png": 23222,
	"./cat.png": 36502,
	"./cyborg.png": 25181,
	"./dazed.png": 2177,
	"./demon.png": 25771,
	"./embarrassed.png": 5365,
	"./fire.png": 13769,
	"./green.png": 12436,
	"./green_laser.png": 93428,
	"./heart.png": 46872,
	"./orange.png": 95469,
	"./pirate.png": 15907,
	"./polygon_glasses.png": 36394,
	"./purple.png": 12553,
	"./purple_laser.png": 49116,
	"./reptile.png": 11640,
	"./snarl.png": 23976,
	"./steampunk.png": 42739,
	"./sunglasses.png": 19863,
	"./uwu.png": 32189,
	"./yellow.png": 61188
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76569;